import { Popover, styled } from '@mui/material';

export const SidebarAddItemsPopoverStyle = styled(Popover)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'transparent',
  },
  '& .MuiPaper-root': {
    marginLeft: theme.spacing(3),
    backgroundColor: theme.palette.case.aquamarine.a900,
    height: 'auto',
    padding: '12px',
    boxSizing: 'border-box',
    minWidth: '56px',
    borderRadius: '8px',
    boxShadow: '0px 15px 60px 0px rgba(38, 44, 74, 0.20)',
  },
}));
